// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"e741da2b","347":"6de8f628","555":"5ea21cd5"}[chunkId] + ".chunk.js";
};